// API Configuration





export const getBaseUrl = () => {

//return "https://sarthibackendservice-bfe2eag3byfkbsa6.canadacentral-01.azurewebsites.net/sarthi-backend/api";
return "https://api.ritesqasarthi.com/sarthi-backend/api";
  // return "http://localhost:8080/sarthi-backend/api";

};


// API Endpoints configuration
export const API_ENDPOINTS = {
  // Vendor Workflow APIs - COMMENTED OUT (created by mistake)
  // VENDOR_WORKFLOW: {
  //   INITIATE_WORKFLOW: '/initiateWorkflow',
  //   PERFORM_TRANSITION_ACTION: '/performTransitionAction',
  //   WORKFLOW_TRANSITION_HISTORY: '/workflowTransitionHistory',
  //   WORKFLOW_TRANSITIONS_PAYMENT_BLOCKED: '/workflowTransitionsPaymentBlocked',
  //   ALL_PENDING_WORKFLOW_TRANSITION: '/allPendingWorkflowtrasition'
  // },

  // Inspection Call APIs
  INSPECTION_CALLS: {
    // Raw Material Inspection
    CREATE_RM: '/inspection-calls/raw-material',
    GET_RM_ALL: '/inspection-calls/raw-material',
    GET_RM_APPROVED: '/inspection-calls/raw-material/approved',
    GET_RM_BY_IC_NUMBER: '/inspection-calls/raw-material/:icNumber',
    GET_RM_HEAT_NUMBERS: '/inspection-calls/raw-material/:icNumber/heat-numbers',

    // Process Inspection
    CREATE_PROCESS: '/inspection-calls/process',
    GET_PROCESS_ALL: '/inspection-calls/process',
    GET_PROCESS_APPROVED: '/inspection-calls/process/approved',
    GET_PROCESS_BY_IC_NUMBER: '/inspection-calls/process/:icNumber',
    GET_PROCESS_LOT_NUMBERS: '/inspection-calls/process/:icNumber/lot-numbers',

    // Final Inspection
    CREATE_FINAL: '/inspection-calls/final',
    GET_FINAL_ALL: '/inspection-calls/final',
    GET_FINAL_BY_IC_NUMBER: '/inspection-calls/final/:icNumber',
    GET_FINAL_AVAILABLE_LOTS: '/inspection-calls/final/available-lots',

    // Common
    GET_BY_ID: '/inspection-calls/:id',
    UPDATE_STATUS: '/inspection-calls/:icNumber/status',
    GET_VENDOR_ICS: '/inspection-calls/vendor'
  },

  // Legacy Inspection APIs (kept for backward compatibility)
  INSPECTION: {
    CREATE: '/inspection/create',
    GET_BY_ID: '/inspection',
    UPDATE: '/inspection/update',
    DELETE: '/inspection/delete'
  },

  CALIBRATION: {
    GET_ALL: '/calibration/all',
    CREATE: '/calibration/create',
    UPDATE: '/calibration/update'
  },

  PAYMENT: {
    GET_ALL: '/payment/all',
    CREATE: '/payment/create',
    UPDATE: '/payment/update'
  },

  // PO Assigned APIs
  PO_ASSIGNED: {
    GET_ALL: '/vendor/po-assigned',
    GET_BY_VENDOR: '/vendor/po-assigned',
    GET_COUNT: '/vendor/po-assigned/count'
  },

  ANNEXURES: '/annexures'
};

// HTTP request timeout in milliseconds
export const REQUEST_TIMEOUT = 60000;

// Default headers for API requests
export const getDefaultHeaders = (token = null) => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  const effectiveToken = token || localStorage.getItem('authToken') || localStorage.getItem('token') || localStorage.getItem('railpad_token');
  if (effectiveToken) {
    headers['Authorization'] = `Bearer ${effectiveToken}`;
  }

  return headers;
};
